import ErrorBoundary from './ErrorBoundary';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from 'styles/globalStyles';
import { theme } from 'styles/theme';
import UserForm from 'components/UserForm';
import { memo, useEffect } from 'react';
import { LayoutWrapper } from 'components/layout/Layout';
import { genratreMapScript } from 'helpers/generateMapScript';
import { getConfigs } from 'store/slices/global.slice';
import { useDispatch, useSelector } from 'react-redux';
import BaseSpinner from 'components/common/BaseSpinner';
import './App.css';
import UserFormNotDTC from 'components/UserFormNotDTC';

const App = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.global);
  useEffect(() => {
    (async () => {
      const { payload } = await dispatch(getConfigs());
      if (payload.key) {
        await genratreMapScript(payload.key);
      } else {
        await genratreMapScript(process.env.REACT_APP_GOOGLE_API_KEY);
      }
    })();
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ErrorBoundary>
        <div className='app'>
          <LayoutWrapper>
            {!loading ? (
              process.env.REACT_APP_DTC_CUSTOMER === 'true' ? (
                <UserForm />
              ) : (
                <UserFormNotDTC />
              )
            ) : (
              <BaseSpinner />
            )}
          </LayoutWrapper>
        </div>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default memo(App);
